<div class="greyhounds-non-runner">
    <div class="non-runners-header">
        <div class="non-runners">{{ sitecore.horseRacing.raceResulted.NonRunners }}</div>
    </div>
    <div class="non-runners-container" [innerHTML]="nonrunnterlist"></div>
</div>
